export class OTA_PersonName {
    public shareMarketInd: string = "No";
    public givenName: string;
    public surname: string;
}
